module.exports = __webpack_public_path__ + "static/media/footer_cas.00283e40.jpg";